import Vue from 'vue';
export const purchaseOrderEvent = new Vue();



// WEBPACK FOOTER //
// ./resources/assets/js/components/purchase-order/purchase-order-event-bus.js